// extracted by mini-css-extract-plugin
module.exports = {"bookCardsList":"BookCardsList_bookCardsList__rfpkA"};